import { CarOutlined, DownloadOutlined, SettingOutlined, UserOutlined } from "@ant-design/icons";
import { Select, TreeSelect } from "antd";
import '../../../style.scss';

import { DownOutlined, SearchOutlined } from '@ant-design/icons';
import { ColDef, GridApi, SelectionChangedEvent } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { Button, ConfigProvider, Input, Modal, Pagination } from 'antd';
import viVN from 'antd/locale/vi_VN';
import dayjs from 'dayjs';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { NodataTable } from "../../../../../../components/NoDataTable";
import { checkDisabledPermission, dataPagination, formatPrice, getUserPermissions } from "../../../../../../until";
import { IDataFilterGroupList, IPagination } from "../../AddGroup/AddNewGroup";
import { useCustomerGroupContext } from "../../../indexV2";
import { IDetailGroup } from "../../../../../../api/groupCustomerV2/groupCustomerV2Api";
import { formatNumber } from "../../../../../../services/mixin";
import useThrottle from "../../../../../../hook/useThrottle";
import useLoading from "../../../../../../hook/useLoading";
import { useSelector } from "react-redux";
import { selectorPermission } from "../../../../../../store/slices/permissionSlice";
import { TypeExportCustomer } from "../../../../../../services/data";

dayjs.locale('vi');


interface Props {
    inforGroup?: IDetailGroup
    memoizedColumnDefs: ColDef<any, any>[];
    listCustomerNoAutomatic: any[];

    pagination: IPagination;
    dataFilterList: IDataFilterGroupList;
    selectedIdCustomer: Set<number>

    setDataFilterList: (dataFilterList: IDataFilterGroupList) => void;
    setSelectedIdCustomer: (data: Set<number>) => void;
    onPaginationChange: (page: number, pageSize: number) => void;
    eListGroupCustomerExcel?: (type: number) => void;
}

const VG_List: React.FC<Props> = ({
    inforGroup, memoizedColumnDefs, listCustomerNoAutomatic,

    pagination, dataFilterList, selectedIdCustomer,

    setDataFilterList, setSelectedIdCustomer, onPaginationChange,
    eListGroupCustomerExcel
}) => {
    const {
        // sLUnit, sLCategoryCar,
        sLCategoryCar, sLNationwide,
        handleOpenDataFields
    } = useCustomerGroupContext();
    const pushLoading = useLoading()

    const permissionSlice = useSelector(selectorPermission)
    const { download } = getUserPermissions(permissionSlice, location.pathname)

    // Download modal state
    const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
   

    const [downloadType, setDownloadType] = useState<number>(TypeExportCustomer.CUSTOMER);

    const handleOpenDownloadModal = () => {
        setDownloadType(TypeExportCustomer.CUSTOMER);
        setIsDownloadModalOpen(true);
    };

    const handleExport = (type: number) => {
        setIsDownloadModalOpen(false);
        // downloadType can be used to differentiate export types when backend supports it
        eListGroupCustomerExcel?.(type);
    };

    //#region ds
    const isRestoringSelection = useRef(false);
    const gridApiRef = useRef<GridApi | null>(null)


    //------------------------------------
    // Định danh duy nhất cho mỗi row
    const getRowId = useCallback((p: { data: any }) => String(p.data.id), []);

    // --- Grid ready ---
    const onGridReady = useCallback((params: { api: GridApi }) => {
        gridApiRef.current = params.api;
    }, []);

    // --- Selection change ---
    const onSelectionChanged = useCallback((event: SelectionChangedEvent) => {
        if (isRestoringSelection.current) return;

        const api = event.api;
        const selectedNodes = api.getSelectedNodes().filter(n => n.data);
        const selectedIdsOnPage = selectedNodes.map(n => Number(n.data.id));

        const currentPageIds = (listCustomerNoAutomatic ?? []).map((row: any) => Number(row.id));

        // --- Tạo bản sao của selectedIds hiện tại ---
        const nextSet = new Set(selectedIdCustomer);

        // --- Xác định phần tử được thêm và bị xóa trên trang HIỆN TẠI ---
        const added: Number[] = [];
        const removed: Number[] = [];

        // Kiểm tra từng ID trên trang hiện tại
        for (const id of currentPageIds) {
            const isCurrentlySelected = selectedIdsOnPage.includes(id);
            const wasPreviouslySelected = selectedIdCustomer.has(id);

            if (isCurrentlySelected && !wasPreviouslySelected) {
                // ID mới được chọn
                added.push(id);
                nextSet.add(id);
            } else if (!isCurrentlySelected && wasPreviouslySelected) {
                // ID bị bỏ chọn
                removed.push(id);
                nextSet.delete(id);
            }
        }

        // console.log('Added:', added, 'Removed:', removed);


        setSelectedIdCustomer(nextSet);

    }, [selectedIdCustomer, listCustomerNoAutomatic]);
    //------------------------------------


    // --- Khôi phục selection khi data mới load ---
    useEffect(() => {
        if (gridApiRef.current && listCustomerNoAutomatic && listCustomerNoAutomatic.length > 0) {
            isRestoringSelection.current = true;

            gridApiRef.current.forEachNode((node: any) => {
                if (node.data && selectedIdCustomer.has(Number(node.data.id))) {
                    node.setSelected(true, false, true);
                } else {
                    node.setSelected(false, false, true);
                }
            });

            setTimeout(() => {
                isRestoringSelection.current = false;
            }, 0);
        }
    }, [listCustomerNoAutomatic, selectedIdCustomer]);
    //#endregion

    return (
        <div className="custom-page-css w-full flex flex-col gap-2 ">
            <div className="custom-page-css flex items-start gap-2">
                <div className="custom-page-css h-fit flex-1 d-flex  gap-2 overflow-hidden">
                    <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center  py-2-px justify-between overflow-hidden">
                        <div className="d-flex align-center w-full" >
                            <TreeSelect

                                className="w-full text-left text-span-select custom-input-focus text-sm bg-FCFCFD-ant-select font-regular p-none-select line-none line-none-item inline-none size-selector border-none"
                                multiple
                                showSearch
                                placeholder="Chọn đơn vị"
                                allowClear
                                value={dataFilterList?.listUnit}
                                treeDefaultExpandAll={false}
                                treeData={sLNationwide}
                                filterTreeNode={(input: string, option: any) =>
                                    typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                onChange={(e) => setDataFilterList({ ...dataFilterList, listUnit: e })}
                            />
                        </div>
                    </div>
                </div>
                <div className="custom-page-css h-fit flex-1 d-flex gap-2 overflow-hidden">
                    <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center  py-2-px justify-between overflow-hidden">
                        <div className="d-flex align-center w-full">
                            <Select
                                showSearch={false}
                                mode="multiple"
                                allowClear
                                className="w-full text-left text-span-select text-sm bg-FCFCFD-ant-select font-regular p-none-select line-none line-none-item inline-none size-selector border-none"
                                popupClassName='position-dropdow custome-select-item h-popUp'
                                variant="borderless"
                                placeholder="Thương hiệu"
                                options={sLCategoryCar}
                                value={dataFilterList?.listCategoryCar}
                                onChange={(e) => setDataFilterList({ ...dataFilterList, listCategoryCar: e })}
                            />

                        </div>
                    </div>
                </div>
                <div className="custom-page-css h-fit flex-2 border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3 py-2-px justify-between overflow-hidden">
                    <Input
                        placeholder="Tìm kiếm thông tin khách hàng "
                        className='custom-input-css custom-page-css border-none custom-input-focus  none-focus-erro'
                        value={dataFilterList.search}
                        onChange={(e) => setDataFilterList({ ...dataFilterList, search: e.target.value })}
                    />
                    <div className=" border-l-F2F4F7 h-full d-flex align-center">
                        <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
                    </div>
                </div>

            </div>
            <div className="custom-page-css flex items-center justify-betweeen gap-1">
                <div className="custom-page-css flex gap-2 items-center">
                    <span className="custom-page-css text-sm font-regular text-344054">{formatPrice(inforGroup?.listCustomer.length) || 0} khách hàng</span>
                </div>
                <div className="custom-page-css flex items-center justify-end gap-2">
                    <div
                        className={`custom-page-css flex gap-2 items-center justify-end cursor-pointer ${checkDisabledPermission(download)}`}
                        onClick={handleOpenDownloadModal}
                    >
                        <span className="custom-page-css text-sm font-regular text-40A9FF">Tải danh sách</span>
                        <DownloadOutlined className="custom-page-css text-sm font-regular text-40A9FF" />
                    </div>
                    <div className="btn-input t-px-8 cursor-pointer"
                        onClick={handleOpenDataFields}
                    >
                        <div className="icon-svg">
                            <SettingOutlined />
                        </div>
                    </div>
                </div>
            </div>
            <div className={`order-history-card__body `}>
                <div className="ag-theme-alpine  custom-table-ag custom-css-table" style={{ width: '100%', height: 610 }}>
                    <AgGridReact
                        className="my-auto-height-grid"
                        getRowStyle={(params: any) => ({
                            backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
                        })}
                        rowData={listCustomerNoAutomatic}
                        columnDefs={memoizedColumnDefs}
                        rowHeight={55}
                        defaultColDef={{
                            resizable: true
                        }}
                        overlayNoRowsTemplate={NodataTable}
                        alwaysShowHorizontalScroll
                        alwaysShowVerticalScroll
                    />
                </div>
                <ConfigProvider locale={viVN}>
                    <div className="pagination-block">
                        <Pagination
                            showSizeChanger
                            current={pagination.current}
                            pageSize={pagination.pageSize}
                            total={pagination.total}
                            itemRender={(page, type, originalElement) => {
                                // Chỉ custom khi là nút số trang
                                if (type === 'page') {
                                    return <span>{formatNumber(page)}</span>;
                                }
                                // prev / next / jump-prev / jump-next giữ nguyên
                                return originalElement;
                            }}
                            showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
                            className='rs-pagination'
                            onChange={onPaginationChange}
                        />
                    </div>
                </ConfigProvider>
            </div>

            {/* Modal chọn loại dữ liệu tải về */}
            <Modal
                title="Tải danh sách khách hàng"
                open={isDownloadModalOpen}
                onCancel={() => setIsDownloadModalOpen(false)}
                footer={
                    <div className="flex justify-between items-center pt-2">
                        <Button onClick={() => setIsDownloadModalOpen(false)}>Huỷ</Button>
                        <Button type="primary" onClick={() => handleExport(downloadType)}>Xuất DS</Button>
                    </div>
                }
                width={480}
                centered
            >
                <p className="mb-3 text-sm" style={{ color: '#344054' }}>
                    Vui lòng chọn loại dữ liệu bạn muốn tải về:
                </p>

                {/* Card 1: Thông tin khách hàng */}
                <div
                    className="custom-page-css flex items-start gap-3 p-4 rounded-2 mb-3 cursor-pointer"
                    style={{
                        border: `1px solid ${downloadType === TypeExportCustomer.CUSTOMER ? '#91D5FF' : '#D9D9D9'}`,
                        backgroundColor: downloadType === TypeExportCustomer.CUSTOMER ? '#E6F7FF' : '#FAFAFA',
                    }}
                    onClick={() => setDownloadType(TypeExportCustomer.CUSTOMER)}
                >
                    <UserOutlined
                        className="text-xl mt-1"
                        style={{ color: downloadType === TypeExportCustomer.CUSTOMER ? '#1890FF' : '#8C8C8C' }}
                    />
                    <div>
                        <div
                            className="font-medium text-sm"
                            style={{ color: downloadType === TypeExportCustomer.CUSTOMER ? '#1890FF' : '#344054' }}
                        >
                            Tải dữ liệu với thông tin khách hàng
                        </div>
                        <div className="text-xs mt-1" style={{ color: '#667085' }}>
                            Chỉ bao gồm thông tin cá nhân của khách hàng (họ tên, số điện thoại, email, ...), không bao gồm thông tin xe sở hữu.
                        </div>
                    </div>
                </div>

                {/* Card 2: Thông tin xe */}
                <div
                    className=" custom-page-css flex items-start gap-3 p-4 rounded-2 cursor-pointer"
                    style={{
                        border: `1px solid ${downloadType === TypeExportCustomer.VEHICLE ? '#91D5FF' : '#D9D9D9'}`,
                        backgroundColor: downloadType === TypeExportCustomer.VEHICLE ? '#E6F7FF' : '#FAFAFA',
                    }}
                    onClick={() => setDownloadType(TypeExportCustomer.VEHICLE)}
                >
                    <CarOutlined
                        className="text-xl mt-1"
                        style={{ color: downloadType === TypeExportCustomer.VEHICLE ? '#1890FF' : '#8C8C8C' }}
                    />
                    <div>
                        <div
                            className="font-medium text-sm"
                            style={{ color: downloadType === TypeExportCustomer.VEHICLE ? '#1890FF' : '#344054' }}
                        >
                            Tải dữ liệu với thông tin xe
                        </div>
                        <div className="text-xs mt-1" style={{ color: '#667085' }}>
                            Bao gồm thông tin cá nhân của khách hàng và thông tin xe sở hữu (biển số, dòng xe, ...).
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default React.memo(VG_List)